module.exports = __webpack_public_path__ + "static/media/ravines-of-northville.94287eb7.pdf";